export async function parsePriceDeckCsv(files, setData) {
  try {
    
    console.log(files);
    
    if (!files.length > 0) return false;
    
    let reader = new FileReader();
    
    reader.readAsText(files[0]);

    let priceDeckData = [];
    
    reader.onload = async (event) => {
      let result = event.target.result;

      if (result.length > 0) {
        let data = result.split('\r\n');
        const headers = data?.splice(0,1)?.[0]?.split(','); // get csv headers
        const commodities = headers?.slice(2, ); // get commodity names

        let colIndices = {
          date: 0,
          cadToUsd: 1
        };

        for (let commodity of commodities) {
          colIndices[commodity] = headers.indexOf(commodity);
        };

        data.forEach(d => {
          if (d.replaceAll(/,/g,'')?.length > 0) {
            const row = d?.split(',');
            let date = new Date(row[colIndices.date]);
            if (date.getDate() === 27 || date.getDate() === 28 || date.getDate() === 29 || date.getDate() === 30 || date.getDate() === 31) {
              date.setDate(2);
              date.setMonth(date.getMonth() + 1);
            };
            priceDeckData.push({
              date: date.toISOString()?.split('T')?.[0],
              cadToUsd: (Number(row[colIndices.cadToUsd]) || 0)
            });

            for (let commodity of commodities) {
              priceDeckData.slice(-1)[0][commodity] = (Number(row[colIndices[commodity]]) || 0);
            };
          };
        });

      };

      if (priceDeckData.length > 0) {
        setData(priceDeckData);
      };
    };
  } catch (error) {
    console.log(error);
    return null;
  };
};
